import React from 'react'

const LearntubeStatsSection = () => {
  return (
    <>
        <div className='md:hidden'>
            <div className='bg-[#2D4F71] flex justify-between py-4 px-8 mx-auto rounded-xl'>
                <div className='text-center'>
                    <p className='text-2xl font-bold'>7L+</p>
                    <p className='text-xs opacity-70 font-medium mr-1'>Active</p> 
                    <p className='text-xs opacity-70 font-medium mr-1'>Users</p>
                </div>
                <div className='text-center'>
                    <p className='text-2xl font-bold'>4.8/5</p>
                    <p className='text-xs opacity-70 font-medium'>Course</p> 
                    <p className='text-xs opacity-70 font-medium'>Rating</p>
                </div>
                <div className='text-center'>
                    <p className='text-2xl font-bold'>34LPA</p>
                    <p className='text-xs opacity-70 font-medium'>Highest</p> 
                    <p className='text-xs opacity-70 font-medium'>Package</p>
                </div>
            </div>
        </div>
        <div className='hidden md:block'>
            <div className='bg-[#2D4F71] flex justify-between py-4 px-8 mx-auto rounded-xl'>
                <div className='text-center'>
                    <p className='text-2xl font-bold'>7L+</p>
                    <p className='text-xs opacity-70 font-medium mr-1'>Active</p> 
                    <p className='text-xs opacity-70 font-medium mr-1'>Users</p>
                </div>
                <div className='text-center'>
                    <p className='text-2xl font-bold'>4.8/5</p>
                    <p className='text-xs opacity-70 font-medium'>Course</p> 
                    <p className='text-xs opacity-70 font-medium'>Rating</p>
                </div>
                <div className='text-center'>
                    <p className='text-2xl font-bold'>34LPA</p>
                    <p className='text-xs opacity-70 font-medium'>Highest</p> 
                    <p className='text-xs opacity-70 font-medium'>Package</p>
                </div>
                <div className='text-center'>
                    <p className='text-2xl font-bold'>967</p>
                    <p className='text-xs opacity-70 font-medium'>Hiring</p> 
                    <p className='text-xs opacity-70 font-medium'>Partners</p>
                </div>
                <div className='text-center'>
                    <p className='text-2xl font-bold'>74%</p>
                    <p className='text-xs opacity-70 font-medium'>Hired In</p> 
                    <p className='text-xs opacity-70 font-medium'>3 Months</p>
                </div>
            </div>
        </div>
    </>
  )
}

export default LearntubeStatsSection